module.exports = __webpack_public_path__ + "img/18.6e6701f8.jpg";